// extracted by mini-css-extract-plugin
module.exports = {"mobileSize":"900","wrapper":"SocialLink-module--wrapper--35-CH","icon":"SocialLink-module--icon--1aNUq"};